import React from "react";
import Title from "@/components/shared/Title";
import {
  FaRegCheckCircle,
  FaClipboardList,
  FaUsers,
  FaClock,
} from "react-icons/fa";
import CountUp from "react-countup";

const featuresData = [
  {
    icon: <FaRegCheckCircle className="h-8 w-8 text-white" />,
    title: "Accurate Results",
    description:
      "We deliver clear and reliable outcomes you can trust in your research.",
  },
  {
    icon: <FaClipboardList className="h-8 w-8 text-white" />,
    title: "Tailored To Your Study",
    description:
      "Every project is unique — we shape the analysis to match your exact research goals.",
  },
  {
    icon: <FaUsers className="h-8 w-8 text-white" />,
    title: "Trusted By Researchers",
    description:
      "From master's students to PhDs — our work speaks in published papers.",
  },
  {
    icon: <FaClock className="h-8 w-8 text-white" />,
    title: "Always On Time",
    description:
      "Deadlines matter. We deliver your results when you need them — fast and reliable.",
  },
];

const statisticsData = [
  {
    value: 1000,
    label: "Project Done",
  },
  {
    value: 300,
    label: "Satisfied Clients",
  },
  {
    value: 64,
    label: "Certificated Award",
  },
  {
    value: 12,
    label: "Years Experience",
  },
];

const Features = () => {
  return (
    <section className="px-4 py-12 text-center md:px-12 xl:px-16">
      <div className="text-center">
        <div className="flex flex-col items-center">
          <Title title="Our Features" className="mb-6 xl:mb-12" />
        </div>

        <h2 className="text-dark mb-6 text-2xl font-semibold md:text-4xl xl:mb-12">
          Core Features that set us <br className="hidden lg:block" />
          apart from the competition
        </h2>

        <div className="mb-14 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {featuresData.map((feature, index) => (
            <div
              key={index}
              className="group hover:ring-primary flex flex-col items-center justify-center rounded-3xl bg-[#F2F2F2] px-4 py-6 ring-2 ring-black/10 transition-all duration-300 hover:scale-105 xl:bg-transparent xl:py-12"
            >
              <div className="bg-primary mb-6 rounded-full p-4">
                {feature.icon}
              </div>
              <h3 className="text-primary mb-4 text-xl font-semibold">
                {feature.title}
              </h3>
              <p className="text-gray text-base">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="">
          <div className="text-gray grid grid-cols-1 gap-12 text-lg font-medium sm:grid-cols-2 xl:grid-cols-4">
            {statisticsData.map((stat, index) => (
              <div
                key={index}
                className="flex flex-col items-center rounded-3xl px-4 py-6 ring-2 ring-black/10"
              >
                <h4 className="text-primary text-3xl">
                  <CountUp
                    start={0}
                    end={stat.value}
                    duration={2}
                    separator=","
                    prefix="+"
                    redraw
                  />
                </h4>
                <p>{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
